export const postersList = [
    {
      title: "MN*C Makeover Bridal Studio",
      description: "Elegant and vibrant poster designs capturing the glamour and style of premium bridal makeover services.",
      link: "/projects",
      image: "/posters/poster1.jpg",
    },
    {
      title: "Renu Makeups",
      description: "Promotional visuals that highlight expert makeup artistry, perfect for weddings, events, and special occasions.",
      link: "/logos",
      image: "/posters/poster2.jpeg",
    },
    {
      title: "Niraman Organization",
      description: "Awareness-driven posters showcasing social initiatives and community welfare programs by Niraman.",
      link: "/posters",
      image: "/posters/poster3.jpeg",
    },
    { 
      title: "SR Tech Creators",
      description: "Professional poster designs used for digital marketing and branding of SR Tech Creators' web services.",
      link: "/projects",
      image: "/posters/poster4.jpeg",
    },
    {
      title: "SR Tech Creators",
      description: "Engaging graphic content designed to promote their creative web development solutions on social media.",
      link: "/logos",
      image: "/posters/poster5.jpeg",
    },
    {
      title: "Niraman Organization",
      description: "Event posters created for health, education, and skill development programs run by Niraman.",
      link: "/posters",
      image: "/posters/poster6.jpeg",
    },
    {
      title: "Niraman Organization",
      description: "Impactful visuals crafted for fundraising and volunteer-driven campaigns led by the organization.",
      link: "/posters",
      image: "/posters/poster7.jpeg",
    },
  ];
